<template>
    <transition name="viewer-fade">
        <div class="el-image-viewer__wrapper" :style="{ 'z-index': zIndex }">
            <div class="el-image-viewer__mask"></div>
            <!-- CLOSE -->
            <span class="el-image-viewer__btn el-image-viewer__close" @click="hide" style="top:1px;right: 7px;background: none;
    font-size: 28px;">
        <!-- <i class="el-icon-circle-close"></i> -->
        <i class="el-icon-close"></i>
      </span>
            <!-- 照片名称 -->
            <div class="imgNameBox" v-if="imageName">
                <div class="imgName" :title="imageName"> {{imageName}}</div>
                <div class="line"></div>
            </div>
            <!-- ARROW -->
            <template v-if="!isSingle">
        <span
            class="el-image-viewer__btn el-image-viewer__prev"
            :class="{ 'is-disabled': !infinite && isFirst }"
            @click="prev">
          <i class="el-icon-arrow-left"/>
        </span>
                <span
                    class="el-image-viewer__btn el-image-viewer__next"
                    :class="{ 'is-disabled': !infinite && isLast }"
                    @click="next">
          <i class="el-icon-arrow-right"/>
        </span>
            </template>
            <!-- ACTIONS -->
            <div class="el-image-viewer__btn el-image-viewer__actions">
                <div class="el-image-viewer__actions__inner">
                    <i class="el-icon-zoom-out" @click="handleActions('zoomOut')"></i>
                    <i class="el-icon-zoom-in" @click="handleActions('zoomIn')"></i>
                    <i class="el-image-viewer__actions__divider"></i>
                    <i :class="mode.icon" @click="toggleMode"></i>
                    <i class="el-image-viewer__actions__divider"></i>
                    <i class="el-icon-refresh-left" @click="handleActions('anticlocelise')"></i>
                    <i class="el-icon-refresh-right" @click="handleActions('clocelise')"></i>
                </div>
            </div>
            <!-- CANVAS -->
            <div class="el-image-viewer__canvas">
                <img
                    v-for="(item, i) in urlList"
                    v-if="i === index"
                    ref="img"
                    class="el-image-viewer__img"
                    :key="isFiledId ? item.fileId : item"
                    :src="currentImg"
                    :style="imgStyle"
                    @load="handleImgLoad"
                    @error="handleImgError"
                    @mousedown="handleMouseDown">
            </div>

        </div>
    </transition>
</template>

<script>
import { on, off } from 'element-ui/src/utils/dom';
import { rafThrottle, isFirefox } from 'element-ui/src/utils/util';

const Mode = {
    CONTAIN: {
        name: 'contain',
        icon: 'el-icon-full-screen'
    },
    ORIGINAL: {
        name: 'original',
        icon: 'el-icon-c-scale-to-original'
    }
};

const mousewheelEventName = isFirefox() ? 'DOMMouseScroll' : 'mousewheel';

export default {
    name: 'elImageViewer',
    props: {
        urlList: {
            type: Array,
            default: () => []
        },
        zIndex: {
            type: Number,
            default: 2000
        },
        currentIndex: {
            type: Number,
            default: 0
        },
        onSwitch: {
            type: Function,
            default: () => {}
        },
        onClose: {
            type: Function,
            default: () => {}
        },
        isFiledId:{
            type:Boolean,
            default:false
        },

    },

    data() {
        return {
            index: 0,
            isShow: false,
            infinite: true,
            loading: false,
            mode: Mode.CONTAIN,
            transform: {
                scale: 1,
                deg: 0,
                offsetX: 0,
                offsetY: 0,
                enableTransition: false
            },
            imgList:[],
            //图片名称
            imageName:""
        };
    },
    computed: {
        isSingle() {
            return this.urlList.length <= 1;
        },
        isFirst() {
            return this.index === 0;
        },
        isLast() {
            return this.index === this.urlList.length - 1;
        },
        currentImg() {
            let currentItem = this.urlList[this.index] || '';
            return this.isFiledId ? this.$utils.getUrlById(currentItem.fileId) :  currentItem;
        },
        imgStyle() {
            const { scale, deg, offsetX, offsetY, enableTransition } = this.transform;
            const style = {
                transform: `scale(${scale}) rotate(${deg}deg)`,
                transition: enableTransition ? 'transform .3s' : '',
                'margin-left': `${offsetX}px`,
                'margin-top': `${offsetY}px`
            };
            if (this.mode === Mode.CONTAIN) {
                style.maxWidth = style.maxHeight = '100%';
            }
            return style;
        }
    },
    watch: {
        currentIndex: {
            handler: function(val) {
                this.index = val;
                this.getImgName(val);
            },
            immediate: true,
        },
        index: {
            handler: function(val) {
                this.reset();
                this.onSwitch(val);
            },
            immediate:true
        },
        currentImg(val) {
            this.$nextTick(_ => {
                const $img = this.$refs.img[0];
                if (!$img.complete) {
                    this.loading = true;
                }
                this.getImgName(this.index);
            });

        }
    },
    methods: {
        hide() {
            this.deviceSupportUninstall();
            this.onClose();
        },
        deviceSupportInstall() {
            this._keyDownHandler = rafThrottle(e => {
                const keyCode = e.keyCode;
                switch (keyCode) {
                    // ESC
                    case 27:
                        this.hide();
                        break;
                    // SPACE
                    case 32:
                        this.toggleMode();
                        break;
                    // LEFT_ARROW
                    case 37:
                        this.prev();
                        break;
                    // UP_ARROW
                    case 38:
                        this.handleActions('zoomIn');
                        break;
                    // RIGHT_ARROW
                    case 39:
                        this.next();
                        break;
                    // DOWN_ARROW
                    case 40:
                        this.handleActions('zoomOut');
                        break;
                }
            });
            this._mouseWheelHandler = rafThrottle(e => {
                const delta = e.wheelDelta ? e.wheelDelta : -e.detail;
                if (delta > 0) {
                    this.handleActions('zoomIn', {
                        zoomRate: 0.15,
                        enableTransition: false
                    });
                } else {
                    this.handleActions('zoomOut', {
                        zoomRate: 0.15,
                        enableTransition: false
                    });
                }
            });
            on(document, 'keydown', this._keyDownHandler);
            on(document, mousewheelEventName, this._mouseWheelHandler);
        },
        deviceSupportUninstall() {
            off(document, 'keydown', this._keyDownHandler);
            off(document, mousewheelEventName, this._mouseWheelHandler);
            this._keyDownHandler = null;
            this._mouseWheelHandler = null;
        },
        handleImgLoad(e) {
            this.loading = false;
            this.$emit('loadSuccess')
        },
        handleImgError(e) {
            this.loading = false;
            e.target.alt = '加载失败';
            this.$emit('loadError')
        },
        handleMouseDown(e) {
            if (this.loading || e.button !== 0) return;

            const { offsetX, offsetY } = this.transform;
            const startX = e.pageX;
            const startY = e.pageY;
            this._dragHandler = rafThrottle(ev => {
                this.transform.offsetX = offsetX + ev.pageX - startX;
                this.transform.offsetY = offsetY + ev.pageY - startY;
            });
            on(document, 'mousemove', this._dragHandler);
            on(document, 'mouseup', ev => {
                off(document, 'mousemove', this._dragHandler);
            });

            e.preventDefault();
        },
        reset() {
            this.transform = {
                scale: 1,
                deg: 0,
                offsetX: 0,
                offsetY: 0,
                enableTransition: false
            };
        },
        toggleMode() {
            if (this.loading) return;

            const modeNames = Object.keys(Mode);
            const modeValues = Object.values(Mode);
            const index = modeValues.indexOf(this.mode);
            const nextIndex = (index + 1) % modeNames.length;
            this.mode = Mode[modeNames[nextIndex]];
            this.reset();
        },
        prev() {
            if (this.isFirst && !this.infinite) return;
            const len = this.urlList.length;
            let index = (this.index - 1 + len) % len;
            if (this.$listeners.change) {
                this.$emit('change', index, this.index, () => {
                    this.index = index;
                });
            } else {
                this.index = index;
            }
        },
        next() {
            if (this.isLast && !this.infinite) return;
            const len = this.urlList.length;
            let index = (this.index + 1) % len;
            if (this.$listeners.change) {
                this.$emit('change', index, this.index, () => {
                    this.index = index;
                });
            } else {
                this.index = index;
            }
        },
        handleActions(action, options = {}) {
            if (this.loading) return;
            const { zoomRate, rotateDeg, enableTransition } = {
                zoomRate: 0.2,
                rotateDeg: 90,
                enableTransition: true,
                ...options
            };
            const { transform } = this;
            switch (action) {
                case 'zoomOut':
                    if (transform.scale > 0.2) {
                        transform.scale = parseFloat((transform.scale - zoomRate).toFixed(3));
                    }
                    break;
                case 'zoomIn':
                    transform.scale = parseFloat((transform.scale + zoomRate).toFixed(3));
                    break;
                case 'clocelise':
                    transform.deg += rotateDeg;
                    break;
                case 'anticlocelise':
                    transform.deg -= rotateDeg;
                    break;
            }
            transform.enableTransition = enableTransition;
        },
        getImgName(index){
            //获取当前图片名称
            if (this.urlList.length && (this.urlList[index] || {}).fileShowName){
                this.imageName=this.urlList[index].fileShowName.slice(0,this.urlList[index].fileShowName.lastIndexOf(''));
            }else {
                this.imageName = ''
            }
        }
    },
    mounted() {
        this.deviceSupportInstall();
    }
};
</script>
<style lang="scss" scoped>
.el-image-viewer__wrapper{
    .el-icon-close:hover{
        color: $themeColor !important;
    }
    .imgNameBox{
        position: absolute;
        top: 0px;
        right: 0px;
        background: rgba(232, 235, 244, 0.7);
        border-radius: 0px 0px 0px 6px;
        opacity: 0.9;
        width: 340px;
        height: 45px;
        text-align: center;
        .imgName{
            font-size: 16px;
            font-weight: 600;
            color: black;
            margin-top: 10px;
            padding-left: 50px;
            height: 22px;
            max-width: 284px;
            text-overflow: ellipsis;
            overflow: hidden;
            white-space: nowrap;
        }
        .line{
            width: 1px;
            height: 45px;
            border-right: 1px solid #C2CCD6;
            padding-left: 270px;
            margin-top: -32px;
        }
    }
}

</style>


